<div class="app-container">
  <ng-container *ngIf="isInitializing">
    <div class="auth-loading-overlay">
      <div class="spinner"></div>
      <p>Initializing application...</p>
    </div>
  </ng-container>
  
  <ng-container *ngIf="!isInitializing && authService.isInteractionInProgress()">
    <div class="auth-loading-overlay">
      <div class="spinner"></div>
      <p> Authenticating...</p>
      
    </div>
  </ng-container>
  
  <router-outlet></router-outlet>
</div>